export default "__VITE_ASSET__COi7yH9A__"